var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("branch_picker_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('branch_picker_page.form_desc'))
    }
  }), _c('coupon-filters', {
    staticClass: "s-mb-3",
    attrs: {
      "options": _vm.filterOptions
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading && _vm.filter == 'qrcode' ? _c('div', [_c('QRCodeScanner', {
    on: {
      "onScan": _vm.onScan
    }
  }), _c('input', {
    staticClass: "search__input mx-auto w-100 mt-3",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": _vm.barcode
    }
  })], 1) : !_vm.showLoading && _vm.filter == 'manual' ? _c('div', [_c('input', {
    staticClass: "search__input m-auto w-100"
  })]) : _vm._e()], 1), _vm.getModuleConfig('branch_picker_page.button_text') || _vm.getModuleConfig('branch_picker_page.cancel_button_text') ? _c('div', {
    staticClass: "p-3 fixed-bottom bg-white footer"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary mb-2"
  }, [_vm._v(_vm._s(_vm.getModuleConfig("branch_picker_page.button_text")))]), _c('SharedButton', {
    staticClass: "s-btn-outline-primary",
    attrs: {
      "variant": "outline-dark"
    }
  }, [_vm._v(_vm._s(_vm.getModuleConfig("branch_picker_page.cancel_button_text")))])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }